<template>
  <div>
    <!-- Start: Header -->
    <section class="section-header-info">
      <div class="container big-container">
        <div class="row">
          <div class="col-sm-12">
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb">
                <li class="breadcrumb-item">
                  <a href="javascript:void(0)">Finance</a>
                </li>
                <li class="breadcrumb-item" aria-current="page">
                  <router-link
                    to="/finance/invoice"
                    class="breadcrumb-item"
                    aria-current="page"
                  >
                    Invoice
                  </router-link>
                </li>
                <li class="breadcrumb-item active" aria-current="page">
                  Update Invoice
                </li>
              </ol>
            </nav>
            <div class="content-header-info">
              <div class="col-sm-12">
                <div class="pull-left">
                  <h2>
                    Update Invoice
                    <span><i class="ic-office"></i></span>
                  </h2>
                  <p>Manage invoice.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- End: Header -->

    <!-- Start: Table -->

    <section class="middle-content">
      <div class="container big-container">
        <form>
          <div class="row">
            <div class="col-sm-12">
              <div class="row">
                <div class="col-sm-4">
                  <div class="form-group">
                    <label class="required" for="company-select">Company</label>
                    <v-select
                      id="company-select"
                      class="v-search-select"
                      placeholder="Company"
                      label="name"
                      v-model="companyId"
                      disabled
                      :options="companyOptions"
                      :clearable="false"
                      :searchable="true"
                      :filterable="true"
                      :reduce="(option) => option.id"
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-4">
                  <div class="form-group">
                    <label class="required" for="company-select">Bill to</label>
                    <textarea
                      class="form-control"
                      v-model="model.billTo"
                    ></textarea>
                    <small
                      class="form-text sts-danger"
                      v-if="isSubmitted && !$v.model.billTo.required"
                      style="display: block"
                    >
                      Bill to is required
                    </small>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-sm-12">
              <div class="box-addons mt-20">
                <div class="panel-group" id="accordion">
                  <div class="panel panel-default">
                    <div class="panel-heading text-center">
                      <h4 class="panel-title">
                        <a
                          data-toggle="collapse"
                          data-parent="#accordion"
                          href="#collapse1"
                          class="--green"
                        >
                          <i class="ic-History mr-10"></i>Items ({{
                            model.items.length
                          }})
                        </a>
                      </h4>
                    </div>
                    <div id="collapse1" class="panel-collapse collapse">
                      <div class="panel-body">
                        <div class="trip-info">
                          <div class="table-responsive table-p15">
                            <table class="table table-hover">
                              <thead>
                                <tr>
                                  <th>Reservation Code</th>
                                  <th>Activity</th>
                                  <th>Description</th>
                                  <th class="text-center">Qty</th>
                                  <th class="text-right">Rate</th>
                                  <th class="text-right">Amount</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr
                                  style="height: 50px"
                                  v-for="(val, index) in model.items"
                                  :key="index"
                                >
                                  <td>
                                    <strong>{{ val.reservationCode }}</strong>
                                  </td>
                                  <td>{{ val.name }}</td>
                                  <td>
                                    <textarea
                                      class="form-control"
                                      v-model="val.description"
                                    ></textarea>
                                  </td>
                                  <td class="text-center">
                                    {{ val.qty }}
                                  </td>
                                  <td class="text-right">
                                    <div class="d-flex flex-column">
                                      <span>
                                        {{ val.currency }}
                                        {{
                                          $currencyFormat(
                                            val.currency,
                                            val.amount
                                          )
                                        }}
                                      </span>
                                      <span
                                        class="local-currency-text"
                                        v-if="
                                          val.currency !== val.localCurrency
                                        "
                                      >
                                        {{ val.localCurrency }}
                                        {{
                                          $currencyFormat(
                                            val.localCurrency,
                                            val.localAmount
                                          )
                                        }}
                                      </span>
                                    </div>
                                  </td>
                                  <td class="text-right">
                                    <div class="d-flex flex-column">
                                      <span>
                                        {{ val.currency }}
                                        {{
                                          $currencyFormat(
                                            val.currency,
                                            val.totalAmount
                                          )
                                        }}
                                      </span>
                                      <span
                                        class="local-currency-text"
                                        v-if="
                                          val.currency !== val.localCurrency
                                        "
                                      >
                                        {{ val.localCurrency }}
                                        {{
                                          $currencyFormat(
                                            val.localCurrency,
                                            val.localTotalAmount
                                          )
                                        }}
                                      </span>
                                    </div>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-sm-12">
              <div class="row">
                <div class="col-sm-6">
                  <div class="form-group">
                    <label class="required">Type</label>
                    <div class="d-flex">
                      <label
                        class="cursor-pointer"
                        v-for="(item, index) in types"
                        :key="index"
                        @click="model.markAsPaid = item.value"
                        :class="{ 'pl-20': index > 0 }"
                      >
                        <input
                          type="radio"
                          class="control-radio"
                          :value="item.value"
                          :checked="model.markAsPaid === item.value"
                          v-model="model.markAsPaid"
                          :disabled="status === 'Paid'"
                        />
                        <span class="pl-5 font-weight-normal v-align-middle">
                          {{ item.text }}
                        </span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-sm-12">
              <div class="row">
                <div class="col-sm-6">
                  <div class="form-group">
                    <label class="required" for="invoice_number"
                      >Invoice Number</label
                    >
                    <input
                      id="invoice_number"
                      type="text"
                      class="form-control"
                      v-model="model.invoiceNumber"
                      disabled
                    />
                    <small
                      class="form-text sts-danger"
                      v-if="isSubmitted && !$v.model.invoiceNumber.required"
                      style="display: block"
                    >
                      Invoice number is required
                    </small>
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="form-group">
                    <label class="required" for="mutation-start-pickup"
                      >Invoice Date</label
                    >
                    <div class="dataTables_filter">
                      <i class="ic-date-picker"></i>
                      <VueCtkDateTimePicker
                        v-model="model.invoiceDate"
                        id="mutation-start-pickup"
                        color="#025BC5"
                        no-label
                        no-header
                        no-button
                        no-button-now
                        format="YYYY-MM-DD"
                        formatted="MMM DD, YYYY"
                        only-date
                      />
                    </div>
                    <small
                      class="form-text sts-danger"
                      v-if="isSubmitted && !$v.model.invoiceDate.required"
                      style="display: block"
                    >
                      Invoice date is required
                    </small>
                  </div>
                </div>
                <div
                  class="col-sm-6"
                  v-if="model.markAsPaid && status === 'Unpaid'"
                >
                  <div class="form-group">
                    <label class="required" for="mutation-start-pickup"
                      >Payment Date</label
                    >
                    <div class="dataTables_filter">
                      <i class="ic-date-picker"></i>
                      <VueCtkDateTimePicker
                        v-model="model.paymentDate"
                        id="mutation-start-pickup"
                        color="#025BC5"
                        no-label
                        no-header
                        no-button
                        no-button-now
                        format="YYYY-MM-DDTHH:mm"
                        formatted="MMM DD, YYYY HH:mm"
                      />
                    </div>
                    <small
                      class="form-text sts-danger"
                      v-if="isSubmitted && !$v.model.paymentDate.required"
                      style="display: block"
                    >
                      Payment date is required
                    </small>
                  </div>
                </div>
                <div class="col-sm-6" v-if="model.markAsPaid">
                  <div class="form-group">
                    <label
                      :class="{
                        required: model.markAsPaid && status === 'Unpaid',
                      }"
                      for="payment_id"
                      >Payment ID</label
                    >
                    <input
                      id="payment_id"
                      type="text"
                      class="form-control"
                      v-model="model.refPaymentId"
                    />
                    <small
                      class="form-text sts-danger"
                      v-if="isSubmitted && !$v.model.refPaymentId.required"
                      style="display: block"
                    >
                      Payment ID is required
                    </small>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-sm-12 mt-20 mb-20">
              <div class="d-flex justify-end gap-20">
                <router-link to="/finance/invoice">
                  <button type="button" class="btn btn-default">Cancel</button>
                </router-link>
                <button
                  type="button"
                  class="btn btn-outline-primary"
                  @click.prevent="submitUpdateInvoice()"
                >
                  Update
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </section>
    <!-- End: Table -->

    <!-- Start: BlockUI -->
    <loader :content="msg" :visible="isLoading" />
    <!-- End: BlockUI -->
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import invoiceService from "@/services/shop/invoiceService.js";
import companyService from "@/services/master/company/companyService.js";

export default {
  data() {
    return {
      collectionReservationCode: [],
      status: "",
      model: {
        invoiceNumber: "",
        invoiceDate: "",
        refPaymentId: "",
        billTo: "",
        markAsPaid: false,
        paymentDate: null,
        items: [],
      },
      companyId: "",
      companyOptions: [],
      types: [
        { value: false, text: "Save" },
        { value: true, text: "Save & Mark as Paid" },
      ],
      isSubmitted: false,
      isLoading: false,
      msg: "Please wait",
    };
  },
  validations() {
    const v = {
      model: {
        invoiceNumber: { required },
        invoiceDate: { required },
        billTo: { required },
        items: { required },
        refPaymentId: this.refPaymentIdValidation,
        paymentDate: this.paymentDateValidation,
      },
    };

    return v;
  },
  computed: {
    refPaymentIdValidation: function () {
      return this.status === "Unpaid" && this.model.markAsPaid
        ? { required }
        : {};
    },
    paymentDateValidation: function () {
      return this.status === "Unpaid" && this.model.markAsPaid
        ? { required }
        : {};
    },
  },
  async created() {
    this.$helper.scrollTop();
    this.isLoading = true;
    await this.getRetrieveInvoice(this.$route.params.id);
    await this.getCompanies();
    this.isLoading = false;
  },
  methods: {
    async getCompanies() {
      this.companyOptions = await companyService.getAllActive();
    },
    async getRetrieveInvoice(id) {
      try {
        const response = await invoiceService.getRetrieveInvoice(id);

        if (response.isSuccess) {
          this.status = response.data.status;
          this.companyId = response.data.companyId;
          this.model = {
            markAsPaid: response.data.status === "Unpaid" ? false : true,
            invoiceNumber: response.data.number,
            invoiceDate: response.data.invoiceDate,
            billTo: response.data.billTo,
            refPaymentId: response.data.paymentId,
            items: [],
          };

          this.model.items = response.data.items.flatMap((item) =>
            item.details.map((val) => ({
              reservationId: item.reservationId,
              reservationCode: item.reservationCode,
              pickUpDate: item.pickUpDate,
              utcPickUpDate: item.utcPickUpDate,
              itemName: item.name,
              itemDescription: item.description,
              itemCurrency: item.txnAmount.currency,
              itemAmount: item.txnAmount.value,
              // details
              description: val.description,
              name: val.name,
              currency: val.txnAmount.currency,
              amount: val.txnAmount.value,
              totalAmount: val.txnAmount.total,
              localCurrency: val.localAmount.currency,
              localAmount: val.localAmount.value,
              localTotalAmount: val.localAmount.total,
              qty: val.qty,
            }))
          );

          this.collectionReservationCode = response.data.items.map(
            (val) => val.reservationCode
          );
        }
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      }
    },
    async submitUpdateInvoice() {
      this.isSubmitted = true;
      this.$v.model.$touch();
      if (this.$v.model.$error) {
        this.$nextTick(() => this.$helper.focusToFieldError());
        return;
      }
      this.isLoading = true;

      await this.editInvoice();

      if (this.status === "Unpaid" && this.model.markAsPaid) {
        await this.markAsPaid();
      }

      this.$router.push({
        path: "/finance/invoice",
      });

      this.isLoading = false;
    },
    async editInvoice() {
      try {
        let itemList = [];

        this.collectionReservationCode.forEach((code) => {
          const filterModelItems = this.model.items.filter(
            (val) => val.reservationCode === code
          );

          const detailData = filterModelItems.map((item) => ({
            name: item.name,
            description: item.description,
            qty: item.qty,
            localCurrency: item.localCurrency,
            localAmount: item.localAmount,
          }));

          const itemListData = {
            reservationId: filterModelItems[0].reservationId,
            name: filterModelItems[0].itemName,
            description: filterModelItems[0].itemDescription,
            currency: filterModelItems[0].currency,
            amount: filterModelItems[0].amount,
            details: detailData,
          };
          itemList.push(itemListData);
        });

        const payload = {
          invoiceDate: this.model.invoiceDate,
          billTo: this.model.billTo,
          items: itemList,
        };

        const response = await invoiceService.updateInvoice(
          this.$route.params.id,
          payload
        );

        if (response.isSuccess) {
          this.$notification.success("Update invoice successfully", {
            title: "Success",
          });
        }
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      }
    },
    async markAsPaid() {
      try {
        let paymentDate = null;

        if (this.model.paymentDate) {
          paymentDate = this.model.paymentDate + ":00";
        }
        const payload = {
          invoiceId: this.$route.params.id,
          refPaymentId: this.model.refPaymentId,
          paymentDate: paymentDate,
        };

        const response = await invoiceService.markAsPaid(
          this.$route.params.id,
          payload
        );

        if (response.isSuccess) {
          this.$notification.success("Mark as paid successfully", {
            title: "Success",
          });
        }
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      }
    },
  },
  updated() {
    this.$helper.collapseMenu("deposit");
    this.$helper.setNavigationClass("invoice-link");
  },
};
</script>



// WEBPACK FOOTER //
// src/components/invoice/EditInvoice.vue